export default __webpack_public_path__ + "static/media/check_Icon.bdd64795.svg";